export const API_CALL = "http://megan.lopsolutions.com/users/";
//export const API_CALL = "http://localhost:3005/users/";
export const DOWNLOAD_CALL = "http://megan.lopsolutions.com/api/download/Megan";

